@if (pushData) {
<gtw-confirmation-modal
 
  [config]="pushConfirmConfig"
  [visible]="false"
  (confirmed)="pushPdfToEfile()"
  (cancelled)="cancel()"
  (closed)="cancel()"
></gtw-confirmation-modal>
}

@if (!pushData) {
<gtw-confirmation-modal
 
  [config]="deleteConfirmConfig"
  [visible]="false"
  (confirmed)="deleteForm()"
  (cancelled)="cancel()"
  (closed)="cancel()"
></gtw-confirmation-modal>
}